import { type BaseLockedResourceRepository } from "../../_Bases/BaseLockedResourceRepository";
import { type LocalDatabaseLockedResource } from "../../_Bases/BaseLockedResourceRepository";
import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import BaseIndexedDBRepository from "../../Implementations/BaseIndexedDBRepository";

export default class IndexedDBLockedResourceRepository extends BaseIndexedDBRepository<
    LocalDatabaseLockedResource
> implements BaseLockedResourceRepository {
    public readonly source: InternalIndexedDBDatabase["lockedResources"];
    protected readonly dataTypeName = "uuid";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.lockedResources;
    }

    public getByResource(resource: string): Promise<LocalDatabaseLockedResource> {
        return this.source.where("resource").equals(resource).first();
    }
}
